var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTips(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_!") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5207\\u56FE",
    transform: "translate(-735.000000, -2304.000000)",
    fill: "#00cfff",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_!",
    transform: "translate(735.000000, 2304.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0 C5.37321429,0 0,5.37321429 0,12 C0,18.6267857 5.37321429,24 12,24 C18.6267857,24 24,18.6267857 24,12 C24,5.37321429 18.6267857,0 12,0 Z",
    id: "\\u5F62\\u72B6",
    opacity: 0.100000001
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1598214,17.4642857 C12.9107143,17.7080357 12.6241071,17.8553571 12.3053571,17.9116071 C12.2035714,17.9169643 12.1044643,17.9196429 12,17.9196429 C11.8955357,17.9196429 11.7964286,17.9169643 11.6946429,17.9116071 C11.3732143,17.8553571 11.0892857,17.7053571 10.8401786,17.4642857 C10.5160714,17.1455357 10.3553571,16.7651786 10.3553571,16.3125 C10.3553571,15.8651786 10.5160714,15.4767857 10.8401786,15.1526786 C11.1642857,14.8285714 11.5526786,14.6651786 12,14.6651786 C12.4473214,14.6651786 12.8357143,14.8285714 13.1598214,15.1526786 C13.4839286,15.4767857 13.6446429,15.8651786 13.6446429,16.3125 C13.6473214,16.7625 13.4866071,17.1482143 13.1598214,17.4642857 Z",
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7875,13.6794643 L11.2419643,13.6794643 C11.0544643,11.3919643 10.3580357,8.24732143 10.3580357,7.81875 C10.3580357,7.32857143 10.5107143,6.91607143 10.81875,6.58392857 C11.1294643,6.24910714 11.5205357,6.08035714 12.0026786,6.08035714 C12.4821429,6.08035714 12.8758929,6.24642857 13.1866071,6.57589286 C13.4946429,6.90803571 13.6473214,7.32053571 13.6473214,7.81875 C13.6473214,8.24732143 13.0044643,11.3919643 12.7875,13.6794643 L12.7875,13.6794643 Z",
    id: "\\u8DEF\\u5F84"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTips);
export default __webpack_public_path__ + "static/media/tips.43e09122a6961a5db2c8e2852162cf51.svg";
export { ForwardRef as ReactComponent };